var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('SkeletonLoader',{staticClass:"selector-input-skeleton",attrs:{"height":"56px"}}):_c('div',{staticClass:"selector-input",on:{"click":_vm.clickHandler}},[_c('elm-actions-search-icon')],1)}
var staticRenderFns = []

export { render, staticRenderFns }